module.exports = __webpack_public_path__ + "assets/ef784f0062f969f2e4e2479e549e1a92.mp3";